import {client} from './services/client'

export  const users = {
    namespaced:true,
    state:{
        users:undefined,
        clients:undefined,
        allClients:undefined,
        histories:undefined,
        user:undefined,
        logs:undefined,
        receiver:undefined

    },
    mutations: {
        SET_USERS (state,users){
            state.users = users
        },
        SET_HISTORIES (state,histories){
            state.histories = histories
        },
        SET_CLIENTS (state,clients){
            state.clients = clients
        },
        SET_ALL_CLIENTS (state,clients){
            state.allClients = clients
        },
        SET_USER (state,user){
            state.user = user
        },
        SET_LOGS (state,logs){
            state.logs = logs
        },
        SET_RECEPTEUR(state, receiver) {
            state.receiver = receiver
        },


    },
    actions: {
        getUsers({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/users/get',
                }).then((response)=>{
                        commit('SET_USERS',response.data.users)
                        resolve(response.data);
                    }).catch((error)=>{
                        reject(error);
                    })
            })

        },
        getClients({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/customers/get',
                }).then((response)=>{
                    commit('SET_CLIENTS',response.data.customers);
                        resolve(response.data);
                    }).catch((error)=>{
                        reject(error);
                    })
            })

        },
        filterClient({commit},data){
            let url = '';
            if (data.isMarchand){
                url = '/marchand/customers/get';
            }else{
                url='/customers/get';
            }
            commit('SET_CLIENTS',undefined);
                client({
                    method : 'get',
                    url:url,
                }).then((response)=>{
                    let clients = response.data.customers;
                    if (data.country_id!==-1){
                        clients = clients.filter((client)=>{if (client.country)return client.country._id===data.country_id;});
                    }
                    commit('SET_CLIENTS',clients);
                }).catch(()=>{})
        },
        getMarchandClients({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/marchand/customers/get',
                }).then((response)=>{
                        commit('SET_CLIENTS',response.data.customers)
                        resolve(response.data);
                    }).catch((error)=>{
                        reject(error);
                    })
            })

        },
        getRecepteur({commit}, email) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'get',
                    url: '/transfers/get/recepteur/'+email,
                }).then((response) => {
                    commit('SET_RECEPTEUR', response.data.receiver);
                    resolve(response);

                }).catch((error) => {
                    reject(error);
                })
            })

        },
        getUserAccountHistoriries({commit},user_id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/users/get/account/histories/'+user_id,
                }).then((response)=>{
                        commit('SET_HISTORIES',response.data.histories)
                        resolve(response.data);
                    }).catch((error)=>{
                        reject(error);
                    })
            })

        },
        getUserAccountDetails({commit},user_id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/users/'+user_id,
                }).then((response)=>{
                        commit('SET_USER',response.data.user)
                        commit('SET_LOGS',response.data.logs)
                        resolve(response.data);
                    }).catch((error)=>{
                        reject(error);
                    })
            })

        },
        filterUsersByRole({commit},role){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'users/filter/by/role/'+role,
                }).then((response)=>{
                        commit('SET_USERS',response.data.users)
                        resolve(response.data);
                    }).catch((error)=>{
                        reject(error);
                    })
            })

        },
        filterUsersByCountry({commit},country){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'users/filter/by/country/'+country,
                }).then((response)=>{
                        commit('SET_USERS',response.data.users)
                        resolve(response.data);
                    }).catch((error)=>{
                        reject(error);
                    })
            })

        },
        updateProfil({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/users/update',
                    data:data,
                })
                    .then((response)=>{
                        commit('SET_USERS',users);
                        if (!response.data.error){
                            sessionStorage.setItem("user",JSON.stringify(response.data.user));
                        }
                        resolve(response.data);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        /*eslint-disable */
        updatePassword({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/users/update/password',
                    data:data,
                }).then((response)=>{
                        resolve(response.data);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteUser({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/users/delete/'+id,
                })
                    .then((response)=>{
                        let users = response.data.users;
                        commit('SET_USERS',users);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
        changeUserStatus({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/users/change/status/'+data.id,
                    data:{reason:data.reason}
                })
                    .then((response)=>{
                        commit('SET_USERS',response.data.users);
                        resolve(response.data);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
        changeUserRole({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/users/change/role/',
                    data:data
                })
                    .then((response)=>{
                        commit('SET_USERS',response.data.users);
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getRecepteur: state => {
            return state.receiver
        }
    }
};
